import { createSelector } from 'reselect'

export const getFeedItemsState = state => state.FeedItemsStore
const getData = state => getFeedItemsState(state).data

const getFeedItems = state => {
  const stateNow = getFeedItemsState(state)
  return !stateNow.data ? {} : stateNow.data.entities.items
}

export const getFeedItemsList = createSelector(
  [getData],
  data => (!data ? null : data.result.map(id => data.entities.items[id]))
)

export const getLastWorkVersion = (state, itemId) => {
  const feedItems = getFeedItems(state)
  const item = feedItems[itemId]
  if (!item) return null
  return item.pa_action.pa_work_versions[
    item.pa_action.pa_work_versions.length - 1
  ]
}
